import {call} from "redux-saga/effects";
import * as HttpService from 'services/HttpService';
import {takeLatest, put} from 'redux-saga/effects';
import {
    getSubscriptionsList,
    subscriptionsSuccess,
    subscriptionsFailed,
    getSubscription,
    subscriptionSuccess,
    subscriptionFailed,
    activeSubscription,
    subscriptionActiveSuccessfully,
    subscriptionActiveFailed,
    inactiveSubscription,
    subscriptionInactiveSuccessfully,
    subscriptionInactiveFailed,
    renewSubscription,
    subscriptionRenewSuccessfully,
    subscriptionRenewFailed,
    deleteSubscription,
    subscriptionDeletedSuccessfully,
    subscriptionDeletionFailed,
    sendSubscriptionPaymentLink,
    sendSubscriptionPaymentLinkSuccessfully,
    sendSubscriptionPaymentLinkFailed,
} from "../slices/subscriptionsSlice";
import {getMember} from "../slices/membersSlice";
import {notification} from "antd";

const endpoint = '/admin/subscriptions';

function* fetchSubs(action) {
    try {
        const response = yield call(HttpService.get, endpoint, action.payload);
        const {subscriptions} = response.data;
        if (subscriptions) {
            yield put(subscriptionsSuccess(subscriptions));
        }
    } catch (error) {
        yield put(subscriptionsFailed());
    }
}

function* fetchSub(action) {
    const {id} = action.payload;
    try {
        const response = yield call(HttpService.get, `${endpoint}/${id}`);
        const {subscription} = response.data;
        if (subscription) {
            yield put(subscriptionSuccess(subscription));
        }
    } catch (error) {
        yield put(subscriptionFailed());
    }
}

function* activateSubscription(action) {
    const {id, memberId} = action.payload;
    try {
        const response = yield call(HttpService.put, `${endpoint}/mark_as_active/${id}`);
        if (response) {
            notification.success({message: 'Success', description: 'Subscription activated successfully'});
            yield put(subscriptionActiveSuccessfully({id}));
            if (memberId) {
                yield put(getMember({id: memberId}));
            }
        }
    } catch (error) {
        yield put(subscriptionActiveFailed());
    }
}

function* inactivateSubscription(action) {
    const {id, memberId} = action.payload;
    try {
        const response = yield call(HttpService.put, `${endpoint}/mark_as_inactive/${id}`);
        if (response) {
            notification.success({message: 'Success', description: 'Subscription marked inactive successfully'});
            yield put(subscriptionInactiveSuccessfully({id}));
            if (memberId) {
                yield put(getMember({id: memberId}));
            }
        }
    } catch (error) {
        yield put(subscriptionInactiveFailed());
    }
}

function* reActivateSubscription(action) {
    const {id, memberId} = action.payload;
    try {
        const response = yield call(HttpService.put, `${endpoint}/renew/${id}`);
        if (response) {
            notification.success({message: 'Success', description: 'Subscription renewed successfully'});
            yield put(subscriptionRenewSuccessfully({id}));
            if (memberId) {
                yield put(getMember({id: memberId}));
            }
        }
    } catch (error) {
        yield put(subscriptionRenewFailed());
    }
}

function* delSubscription(action) {
    const {id, memberId} = action.payload;
    try {
        const response = yield call(HttpService.del, `${endpoint}/${id}`);
        if (response) {
            notification.success({message: 'Success', description: 'Subscription deleted successfully'});
            yield put(subscriptionDeletedSuccessfully({id}));
            if (memberId) {
                yield put(getMember({id: memberId}));
            }
        }
    } catch (error) {
        yield put(subscriptionDeletionFailed());
    }
}

function* sendPaymentLink(action) {
    const {id, memberId} = action.payload;
    try {
        const response = yield call(HttpService.put, `${endpoint}/${id}/send_payment_link`);
        if (response) {
            notification.success({message: 'Link Sent', description: 'Payment link sent successfully'});
            yield put(sendSubscriptionPaymentLinkSuccessfully({id}));
            if (memberId) {
                yield put(getMember({id: memberId}));
            }
        } else {
            notification.error({message: 'Error', description: 'Payment link could not be sent'});
            yield put(sendSubscriptionPaymentLinkFailed());
        }
    } catch (error) {
        notification.error({message: 'Error', description: 'Payment link could not be sent'});
        yield put(sendSubscriptionPaymentLinkFailed());
    }
}

export default function* resourcesSaga() {
    yield takeLatest(getSubscriptionsList.type, fetchSubs);
    yield takeLatest(getSubscription.type, fetchSub);
    yield takeLatest(activeSubscription.type, activateSubscription);
    yield takeLatest(inactiveSubscription.type, inactivateSubscription);
    yield takeLatest(renewSubscription.type, reActivateSubscription);
    yield takeLatest(deleteSubscription.type, delSubscription);
    yield takeLatest(sendSubscriptionPaymentLink.type, sendPaymentLink);
}
